import React, { useEffect, useState } from "react"
import { FaRegClock } from "react-icons/fa";
import { GrLocation } from "react-icons/gr";
import "./header.scss"
import BackgroundImage from "gatsby-background-image"
import CustomMarkdown from "../../utils/customMarkdown"
import { getImage, GatsbyImage } from "gatsby-plugin-image"
import Modal from "../modal/modal"
import { useLocation } from "@reach/router"
// import HeaderLogo from "../../assets/lt-gold.png"
// import { convertToBgImage } from "gbimage-bridge"


const Header = ({ Title, Subtitle, FirstCTATitle, FirstCTAURL, SecondCTATitle, SecondCTAURL, ThirdCTATitle, ThirdCTAURL, Background, Icon, HeaderHeight, FooterInformation }) => {

    // let bgImagePlugin = null;
    // if (Background) {
    //     console.log(Background, "test")

    //     const image = getImage(Background)

    //     console.log(getImage(Background), "test image")
    //     bgImagePlugin = convertToBgImage(image)

    // }

    // console.log(bgImagePlugin, "bgimage")

    var headerHeightStyle
    switch (HeaderHeight) {
        case "small":
            headerHeightStyle = { minHeight: '215px' }
            break;
        case "medium":
            headerHeightStyle = { minHeight: '665px' }
            break;
        case "large":
            headerHeightStyle = { height: 'calc(100vh - 85px)' }
            break;

        default:
            break;
    }

    var disclaimerInfo = FooterInformation?.split("|");
    var disclaimerScheduleInfo = "";
    var disclaimerAddressInfo = "";
    if(disclaimerInfo != null && disclaimerInfo != undefined){
        if(disclaimerInfo.length > 0){
            disclaimerInfo.forEach((item, index) => {
                if(index < (disclaimerInfo.length - 1)){
                    disclaimerScheduleInfo += (item + "<br>");
                }else{
                    disclaimerAddressInfo = item;
                }
            });
        }
    }

    const [showModal, setShowModal] = useState(false);

    const openModal = () => {
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
    };

    const handleGtagHeaderReservation = () => {
        if (typeof window !== 'undefined' && typeof window.gtag !== 'undefined') {

            window.gtag('event', 'header-make-a-reservation');

        }
    }


    useEffect(() => {
        if (Background && Background.fluid && Background.fluid && Background.fluid.srcWebp) {
            const preloadLink = document.createElement("link");
            preloadLink.href = Background.fluid.srcWebp;
            preloadLink.rel = "preload";
            preloadLink.as = "image";
            document.head.appendChild(preloadLink);
        }
    }, [])

    const location = useLocation();

    const isHomePage = location.pathname === "/";


    return (
        <>

            <BackgroundImage Tag="section" role="img" className="background-zindex" fluid={Background.fluid || ["rgba(0,0,0,0)"]}>
                <div className="header header-container-gradient" style={headerHeightStyle}>

                    <div className="header-content">

                        <div className="logo">
                            {Icon ?
                                <div className="secondary-image">
                                    <GatsbyImage image={Icon?.gatsbyImageData} alt="header image" ></GatsbyImage>
                                    {/* <img src={HeaderLogo} alt="header image"></img> */}
                                </div>
                                : ''
                            }

                            {
                                Title.split('#').length > 1 ?
                                    <div className="title-block">
                                        <h1 className="title">{Title.split('#')[0]}</h1>
                                        <h2 className="subtitle">{Title.split('#')[1]}</h2>
                                        {Title.split('#')[2] ? <span className="split-title">{Title.split('#')[2]}</span> : ""}
                                    </div>
                                    : <h1 className="simple-title">{Title}</h1>
                            }
                        </div>


                        {
                            Subtitle?.split('#').length > 1 ?
                                <div className="subtitle-block">
                                    <p>{Subtitle.split('#')[0]}</p>
                                    <p>{Subtitle.split('#')[1]}</p>
                                    {Subtitle.split('#')[2] ? <span className="split-subtitle">{Subtitle.split('#')[2]}</span> : ""}
                                </div>
                                : <p>{Subtitle}</p>
                        }

                        <div className="">
                            {
                                FirstCTATitle ?
                                    <div className="header__cta">
                                        <a rel="noopener noreferrer" href={FirstCTAURL} className="cta">{FirstCTATitle}</a>
                                    </div>
                                    : ""
                            }
                            {
                                SecondCTATitle ?
                                    <div className="header__cta">
                                        <a rel="noopener noreferrer" href={SecondCTAURL} className="cta">{SecondCTATitle}</a>
                                    </div>
                                    : ""
                            }
                            {
                                ThirdCTATitle ?
                                    ThirdCTATitle.includes("Reservation") ?
                                        <div className="header__cta">
                                            <button onClick={() => { openModal(); handleGtagHeaderReservation() }} className="button-cta">{ThirdCTATitle}</button>
                                            {
                                                showModal && <Modal show={showModal} handleClose={closeModal} />
                                            }
                                        </div>
                                        :
                                        <div className="header__cta">
                                            <a rel="noopener noreferrer" href={ThirdCTAURL} className="cta">{ThirdCTATitle}</a>
                                        </div>
                                    : ""
                            }
                            {
                                isHomePage ? 
                                    <div className="header__cta">
                                        <a href={'/assets/christmas-menu.pdf?t='+new Date().getTime()} target="_blank" rel="noopener noreferrer" className="cta secondary-cta">
                                            Christmas menu
                                        </a>
                                    </div>
                                :""
                            }

                        </div>

                    </div>

                    {
                        FooterInformation ?
                            <div className="header-disclaimer">
                                <div className="header-disclaimer-wrapper">                              
                                {
                                    disclaimerScheduleInfo != "" ? 
                                        <div className="header-discalimer-container">
                                            <div className="header-disclaimer-icon"><FaRegClock /></div>
                                            <div className="disclaimer-paragraph"> <CustomMarkdown>{disclaimerScheduleInfo}</CustomMarkdown></div>
                                        </div>
                                    : ""
                                }
                                {
                                    disclaimerAddressInfo != "" ?
                                        <div className="header-discalimer-container">
                                            <div className="header-disclaimer-icon"><GrLocation /></div>
                                            <div className="disclaimer-paragraph"> <CustomMarkdown>{disclaimerAddressInfo}</CustomMarkdown></div>
                                        </div>
                                    : ""
                                }
                                
                                {/* <CustomMarkdown className="disclaimer-paragraph">{FooterInformation}</CustomMarkdown> */}
                                </div>
                            </div>
                        : ""
                    }

                </div>
            </BackgroundImage>

        </>
    )
}

export default Header